module.exports = __webpack_public_path__ + "media/Garage-Door_Pairing-Mode_Animation.6667070b.mp4";